import { render, staticRenderFns } from "./SH041ShopperTdkInfoSetting.vue?vue&type=template&id=9d8ec262&scoped=true&"
import script from "./SH041ShopperTdkInfoSetting.vue?vue&type=script&lang=js&"
export * from "./SH041ShopperTdkInfoSetting.vue?vue&type=script&lang=js&"
import style0 from "./SH041ShopperTdkInfoSetting.vue?vue&type=style&index=0&id=9d8ec262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8ec262",
  null
  
)

export default component.exports